var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 615.83 699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Gradiente_sem_nome_98);}.cls-2{fill:url(#Gradiente_sem_nome_120);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_98",
    x1: 313.63,
    y1: 674.08,
    x2: 925.89,
    y2: 420.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#054b60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9b3294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#963992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#884e8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#727080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#529e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#2bd95e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1cef57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_120",
    x1: 150.18,
    y1: 652.76,
    x2: 515.89,
    y2: 501.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#0e648f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#07c1f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9b3294"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M848.06,316.74V582.08c0,134.46-64.53,246.59-193.12,289.37-109.13-19.15-196.67-101-224.1-207.07,17.17,52.26,55.76,71.17,118.22,71.17C623.31,735.55,660,689,660,587V191h80.19C810.44,191,848.06,226.64,848.06,316.74Z",
    transform: "translate(-232.23 -191)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M430.84,664.38c-7-21.47-10.49-48.57-10.49-82.3V320.7c0-94.06-47.53-129.7-107.92-129.7h-80.2V588c0,184.16,123.76,302,299,302,46.29,0,87.52-6.53,123.7-18.55C545.81,852.3,458.27,770.44,430.84,664.38Z",
    transform: "translate(-232.23 -191)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.efd6132f3c052bdd8a409eb8f95ba460.svg";
export { ForwardRef as ReactComponent };